import { ACTIONS } from '../../../constants';
import { IHeaderHideAlertAction } from '../../reducers/types';

export const hideAlert = (): IHeaderHideAlertAction => ({
  type: ACTIONS.HIDE_ALERT,
});
